export default {
  main: {
    title: 'バージョンの確認',
    language: '日本語',
    intro:
      'バージョンの確認は、バージョン間のMD5またはSHA256ハッシュ値を照合することによって行われます。トークンポケットウォレットを公式チャンネルからダウンロードすることを確認して、騙されないようにしてください。バージョンのMD5またはSHA256ハッシュ値の取得方法についての手順は、 ',
    tutorial: 'チュートリアルを参照してください >',
    system: 'OS',
    android: 'Android',
    ios: 'iOS',
    version: 'バージョン',
    allVersion: '全て',
    appChannel: 'アプリチャンネル',
    developer: '開発者',
    allChannel: '全て',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'バージョンログ',
    check: '詳細',
    versionLog: 'バージョンログ',
    confirm: '確認',
    aboutIOS: 'iOSバージョンについて',
    IOSDesc:
      'iOSバージョンについては、当社のアプリはApp Storeでのみ提供されています。App Storeからダウンロードされたアプリのみが正しくインストールされます。したがって、Appleデバイスを使用する場合は、App Storeを唯一のダウンロードチャンネルとして認証してください。',
    IOSDesc_2:
      '2022年10月8日以前にApp Storeからダウンロードされたバージョンの開発者はTOKENPOCKET FOUNDATION LTDであり、TokenPocketによって開発された初期のバージョンです。正規のウォレットであり、通常使用することができますが、更新サービスは一時的に中断されます。',
    aboutAndroid: 'Android バージョンについて',
    androidDesc: '現在のTokenPocketのAndroidダウンロードチャネルには、公式ウェブサイト、Google Playストア、Samsungアプリストア、Huaweiアプリギャラリー、OPPOアプリストア、Vivoアプリストアが含まれています。一部のアプリストアでは、ダウンロード中にAPKインストールパッケージを取得できないため、MD5またはSHA256の計算検証を行うことができません。したがって、ダウンロードする際には、開発者情報を正確に確認し、以下を参照してください！',
    IOSAppName: 'アプリ名:',
    TPWallet: 'TPウォレット',
    AppIcon: 'アプリアイコン:',
    AppDeveloper: '開発者:',
    downloadLink: 'ダウンロードURL:',
    copied: 'コピーしました！',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'フォローする',
    desc1: 'TokenPocket スタッフからプライベート メッセージは送信されません!',
    desc2:
      '注意！ TokenPocket コミュニティに参加しようとしています。誰かが私たちになりすましてプライベート メッセージを送信している可能性があります。 プライベート メッセージを送信する人は詐欺師である可能性があることに注意してください。 最初に連絡することはありません！',
    desc3: '了解、入力',
  },
  COMMON: {
    LAYOUT: {
      features: 'プロダクト',
      products: 'プロダクト',
      buyCryptoFooter: '暗号通貨を購入する',
      mobileWallet: 'モバイルウォレット',
      mobileWalletDesc: 'ブロックチェーンのモバイルウォレット。',
      hardwareWallet: 'ハードウェアウォレット',
      hardwareWalletDesc: '資産を守るためにKeyPalを手に入れよう！',
      extensionWallet: 'ブラウザ拡張ウォレット',
      extensionWalletDesc: 'コンピューター上でのより良いウォレット',
      desktop: 'デスクトップウォレット',
      fiveDegrees: '5Degrees',
      versionVerification: 'バージョン検証',
      versionVerificationDesc: 'ウォレットの検証',
      approvalDetector: 'アプルーバルディテクター',
      approvalDetectorDesc: 'アプルーブの表示とリボーク',
      tokenSecurity: 'トークンセキュリティ',
      tokenSecurityDesc: 'トークンのコントラクトアドレスを監査',
      keyGenerator: 'キージェネレーター',
      keyGeneratorDesc: 'さまざまなネットワークの公開鍵と秘密鍵をランダムに生成',
      tokenProfile: 'トークンプロファイル',
      tokenProfileDesc: 'トークンに関する全ての情報を確認',
      tokenClaim: 'トークンクレーム',
      tokenClaimDesc: 'エアドロップを受け取る',
      easyInscription: 'イージーインスクリプション',
      easyInscriptionDesc: '安全かつ簡単なインスクリプションのためのツール',
      nostrAssetsBatchSender: 'NostrAssetsバッチトランスファー',
      nostrAssetsBatchSenderDesc: 'NostrAssetsのためのバッチトランスファーツール',
      BATCH_SENDER: 'バッチトランスファー',
      BATCH_SENDER_DESC: '複数のアドレスに一度にトークンを転送',

      trade: '取引',
      swap: 'TransitSwap',
      swapDesc: 'ベストレートで取引。',
      bridge: 'Bridge',
      bridgeDesc: 'Ensuring seamless asset liquidity.',
      buyCrypto: '購入',
      buyCryptoDesc: 'クレジットカードで暗号資産を購入',
      market: '市場',
      marketDesc: 'リアルタイムインサイトでトレンドのトークンを見つける',

      information: '詳細',
      blockchainGuide: 'ブロックチェーンガイド',
      tronWallet: 'TRON Guide',
      iostWallet: 'IOST Guide',
      tpMan: 'TPマン',

      developers: '開発者',
      github: 'Github (TP-Lab)',
      devCenter: '開発者センター',
      developersDesc: 'TokenPocket開発者向けドキュメント',
      subToken: 'トークンを投稿',
      subTokenDesc: 'トークンを投稿',
      subDApp: 'DAppの投稿',
      subDAppDesc: 'DAppを投稿し、監査後に表示',
      subNFT: 'NFTの投稿',
      subNFTDesc: 'NFTとアート作品の投稿',
      subChain: 'チェーンを投稿',
      subChainDesc: 'ブロックチェーンをを投稿',
      bugBounty: 'バグバウンティ',

      tools: 'ツール',

      build: 'ビルド',

      learn: '学ぶ',

      explorer: 'エクスプローラー',

      company: '会社',
      about: 'TokenPocketについて',
      careers: 'キャリア',
      pressKit: 'ブランドキット',
      swagShop: 'スワッグショップ',

      support: 'サポート',
      helpCenter: 'ヘルプセンター',
      helpCenterDesc: '問題解決のためのアシスタント',
      contactUs: 'お問い合わせ',
      contactUsDesc: '提案を共有と質問',
      forum: 'フォーラム',
      forumDesc: 'コミュニティメンバーとの会話を楽しむ',

      legal: '法的情報',
      privacyPolicy: 'プライバシーポリシー',
      terms: '利用規約',

      toHome: 'ホーム',
      defiWallet: 'DeFiウォレット',
      ETHWallet: 'イーサリアムウォレット',
      ethWallet: 'ETHウォレット',

      dappStore: 'DAppストア'
    }
  }
};
